import React from "react";
import { Modal } from "antd";

const PaymentModal = ({ ispaymentModalOpen, showpaymentModal }) => {
  return (
    <>
      <Modal
        open={ispaymentModalOpen}
        onCancel={showpaymentModal}
        centered
        footer={null}
        className="white-label-payment-modal"
      >
        <div className="head">
          <h5>Unlock Endless Possibilities</h5>
          <h6>$0.99/min</h6>
        </div>
        <div className="input-wrap">
          <label>Card Number</label>
          <div className="input-div">
            <input type="number" placeholder="Enter card number" />
          </div>
        </div>
        <div className="grid-div">
          <div className="input-wrap">
            <label>Issue Date</label>
            <div className="input-div">
              <input type="date" placeholder="Enter card number" />
            </div>
          </div>
          <div className="input-wrap">
            <label>Expiry Date</label>
            <div className="input-div">
              <input type="date" placeholder="Enter card number" />
            </div>
          </div>
          <div className="input-wrap">
            <label>CVV Number</label>
            <div className="input-div">
              <input type="number" placeholder="2345" />
            </div>
          </div>
        </div>
        <button
          className="cursor-pointer btn-primary"
          onClick={showpaymentModal}
        >
          Submit
        </button>
      </Modal>
    </>
  );
};

export default PaymentModal;
